import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { msalInstance, msalInitializePromise } from './authConfig';
var rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element with id "root" was not found in the document.');
}
var root = createRoot(rootElement);
msalInitializePromise.then(function() {
    root.render(/*#__PURE__*/ _jsx(React.StrictMode, {
        children: /*#__PURE__*/ _jsx(Router, {
            children: /*#__PURE__*/ _jsx(App, {
                instance: msalInstance
            })
        })
    }));
}).catch(function(error) {
    console.error('Failed to initialize MSAL', error);
    root.render(/*#__PURE__*/ _jsx("p", {
        children: "Something went wrong while starting the application. Please refresh the page."
    }));
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
